import React from "react";
import Letterhead from "../../../complienceReports/Reusable/Letterhead";
import MetaInfo from "../../../complienceReports/Reusable/MetaInfo";
import SubjectLine from "../../../complienceReports/Reusable/SubjectLine";
import Signature from "../../../complienceReports/Reusable/Signature";


interface AwoAppointmentLetterProps{
    refNo: string,
    date: string,
    name: string,
    address: string,
    joining_Date: string,
    Joining_Year: string,
    State: string,
    DOB: string,
    Last_date: string,
    district: string,
    Reporting_RWO: string,
    
}


function AWOappointment({refNo, date, name, address, joining_Date, Joining_Year, State, DOB, Last_date, district, Reporting_RWO}: AwoAppointmentLetterProps){

    return (
           <>
           <h2 className="float-right font-semibold text-[11px]" style={{fontFamily: "Times New Roman"}}>Page 1 of 9</h2>
           <Letterhead />
           
           <hr className=" mx-auto w-4/4 border-t-2 border-black"/>
               <MetaInfo refNo={refNo} date={date}/>
               <SubjectLine subject="Appointment Letter" />
               <h2 className="text-center text-sm" style={{fontFamily: "Times New Roman"}}>(confidential)</h2>

               <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
        <b>Name :-</b> {name} <br />
        <b>Address :-</b> {address}
      </p>
      <br/>
      <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>Dear <b>{name}</b>,</p>
      <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
        We are pleased to inform you that you are hereby appointed as <b>AWO</b> in the Dept. of <b>Business Development</b> under the
        programme of <b>National Healthcare and Wellness Mission</b>,
        H. No. 01, Karbi Namghar Path, Khagen Mahanta Road, Hengrabari Near
        Karbi Namghar, Barbari, Guwahati, Assam – 781036, as per terms and
        conditions as under:-
      </p>
       <br/>
      <ol className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
        <li>
        <b>1)</b> This appointment shall be effective from <b>{joining_Date}</b>, <b>{Joining_Year}</b>.
            You are appointed to work remotely from your residence, reporting
            virtually to the designated authority of the Company. Depending on
            business needs, you may need to travel to Company offices, project and
            presentation sites, or client/customer locations as required.
        </li>
        <br/>
        <li>
         <b>2)</b> Your salary and other allowances shall be as per enclosed statement in{" "}
            <b>Annexure A</b>.
        </li>
        <br/>
        <li>
        <b>3)</b> Your job functions and responsibilities as an AWO in the Dept. of <b>Business Development</b> for the State of <b>{State}</b>, covering <b>{district}</b> district
            under the NHWM programme of OHWPL will be broadly defined in this
            Appointment Letter.
        </li>
        <br/>
        <li>
        <b>4)</b> You will be placed on probation for a period of twelve (12) months. On
          the expiry of this period, if you are not confirmed in writing, your
          services shall be deemed to be automatically terminated. Unless such
          written confirmation is issued, you shall not be considered a
          permanent employee.
          <br />
          During the probation period, either party may terminate this
          appointment by giving forty-five (45) days’ notice in writing. Upon
          confirmation, the notice period required from either side shall be
          sixty (60) days.
        </li>
        <br/>
        <li>
        <b>5)</b> Violation of the Zero Tolerance Policy (Point No. 31) or any other
          company policy will result in termination without any notice period.
          In cases of underperformance, the company may initiate an
          auto-termination process with a 30-day notice period, during which the
          employee will be placed on a Performance Improvement Plan (PIP).
        </li>
      </ol>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <div className="mt-10 flex flex-col items-end" style={{fontFamily: "Times New Roman"}}>
  <p className="text-[11px] px-8">Accepted by:-</p>
  <br />
  <p className="font-semibold text-sm px-8">{name}</p>
</div>
    
      <br/>       
      <br/>
      <h2 className="float-right font-semibold text-[11px]" style={{fontFamily: "Times New Roman"}}>Page 2 of 9</h2>
      <br/>
      <br/>
       <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
        <b>6)</b> Following the successful completion of your probation, you will be
        formally confirmed in writing as a permanent member of the Company’s
        staff. You shall be eligible for statutory and service benefits and be
        subject to discipline and other rules prevailing or may come into effect
        from time to time, as and when applicable according to rules of the
        Company and such other benefits as applicable to employees regularised
        from time to time to the place/location wherever you are employed. The
        company subject to requirement shall take appropriate cover of GPA to
        take care of the liability under the Workmen Compensation Act upon
        successful completion of the probationary period, if you are not covered
        by ESI Scheme.
      </p>
      <br/>
      <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
      <b>7)</b> Your future increments or promotion or any other salary increase
        shall be based on merit considering your periodic and consistent overall
        performance, business conditions and other parameters fixed from time to
        time at the discretion of the management and shall not be considered
        merely as a matter of right.
      </p>
       <br/>
      <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
      <b>8)</b> During the period of service with the company, you shall not indulge
        and/or take part in any activity of formation of council and/or
        association or become a member being part of management staff which are
        found to be detrimental in the interest of the company in any way. No
        employee shall create or engage in any social media channels, groups,
        broadcasts, or similar platforms involving company employees or any
        other persons in a manner that may harm the interests or reputation of
        the Company. Employees are strictly prohibited from personally
        contacting their peers without prior written approval from their
        Reporting Authority or the Company’s Management. Such an action shall be
        deemed as infringement to service conditions of the company and amount
        to causing damage to its interest and shall call for disciplinary action
        being taken against you, as it may deem fit and appropriate.
      </p>
      <br/>
      <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
      <b>9)</b> You shall retire from the services of the Company on attaining 60
        years of age. Your date of birth for the purpose of Company’s record is
        entered as <b>{DOB}</b> as per scanned copy of PAN Card submitted by
        you. Extension of service up to the age of 65 will be subject to a
        medical assessment conducted at a Company-recommended Medical Center.
      </p>
       <br/>
      <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
      <b>10)</b> Your services are liable to be transferred or you may be assigned:
      </p>
       
      <ul className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
        <li>
          i. With/without transfer, in full or part, from one department to
          another or to office/branch and vice-versa, or office/branch to
          another office/branch of an associate/sister concern of the Company,
          in India or overseas or any other company which is promoted by the
          same management in India or overseas or any other concern where this
          Company has any interest. In such case, you shall be governed by the
          terms and conditions applicable for the location concerned and/or
          governed by respective Government service conditions and other terms
          of the said concern as may be prescribed from time to time.
        </li>
        <li>
          ii. The aforesaid Clause (i) will not give you any right to claim
          employment with any associate/sister concern, or ask for a common
          seniority with the employee of sister/associate concern.
        </li>
      </ul>
       <br/>
       <br/>
       <br/>
       <br/>
       <br/>
       <br/>
       <br/>
      <div className="mt-10 flex flex-col items-end" style={{fontFamily: "Times New Roman"}}>
  <p className="text-[11px] px-8">Accepted by:-</p>
  <br />
  <p className="font-semibold text-sm px-8">{name}</p>
</div>
      <br/>
      <br/>
      <br/>
      <h2 className="float-right font-semibold text-[11px] mt-[-30px]" style={{fontFamily: "Times New Roman"}}>Page 3 of 9</h2>
      <br/>
      <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
      <b>11)</b> All leave requests must be submitted in advance and are subject to approval by the Management. During the probationary period, employees shall not be entitled to leave. 
        Absence from duty or failure to log in for two consecutive working days without prior approval, or overstaying sanctioned leave without permission, will be treated as abandonment of employment. 
        In such cases, the Management shall deem the employee to have voluntarily abandoned the services of the Company, which may result in automatic termination.
      </p>
      <br/>
      <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
      <b>12)</b>	Your services are liable to be terminated at any time :-
          <ul className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
            <li>
              i. during probation or after confirmation, 
              in case you are found to be medically unfit by the Company’s Authorized Medical Practitioner, on examination;
            </li>
            <li>
              ii.	as and when the Company comes to know of any conviction by the Court of Law during the tenure of your service with us or conviction and / or any bad record in the past under 
              the previous employer, or because of your giving false information at the time of your appointment or concealed any 
              material information or given any false details in the application form or otherwise as regard age, education qualification, experience, salary etc.
            </li>
            <li>
              iii.	if you are found to be not possessing desired qualification which do not confirm to custom authority and / govt. 
              regulation as may be required from time to time and necessary for continuation of business or its exigencies or on account of redundancy.
            </li>
          </ul>
      </p>
      <br/>
      <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
      <b>13)</b>	You will keep the Company informed of any change in your residential address that may happen 
        during the course of employment of your service with the company.
      </p>
      <br/>
      <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
      <b>14)</b>	All documents, plans, drawings, prints, trade secrets, technical information reports, statements, correspondence etc. written or unwritten and also information and instructions that pass through you or come to your knowledge shall be treated as confidential. 
        You shall not utilize them for your own use or disclose to other persons during or after your employment. During the course of employment with the Company, you will acquire, gain generate, gather and develop knowledge of and be given access to business information about 
        products activities, know–how, methods or refinements and business plans and business secrets and other information concerning the products/business of the Company, hereinafter called the “SECRETS”. 
        You will be liable for prosecution for damages for divulgence, sharing, or parting any of such information during the course of employment and on cessation for at least 2 years. 
      </p>
      <br/>
      <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
        <b>15)</b>	You shall faithfully and to the best of your ability perform all duties entrusted to you by the management from time to time. You will be bound by the rules, regulations, and policies of the Company 
        relating to conduct, discipline, and other matters as applicable. You shall not seek membership in any local or public body without prior written permission from the management. 
        Any violation of this condition will be treated as a breach of employment terms, and the management reserves the right to take appropriate action as it deems fit.
      </p>
      <br/>
      <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
      <b>16)</b>	You shall not, either during your employment or thereafter, disclose to any person by word of mouth, writing, or otherwise, any business, administrative, or organizational 
        information of a confidential nature that comes to your knowledge by virtue of your employment.
      </p>
      <br/>
      <br/>
      <br/>
      <div className="mt-10 flex flex-col items-end" style={{fontFamily: "Times New Roman"}}>
  <p className="text-[11px] px-8">Accepted by:-</p>
  <br/>
  <p className="font-semibold text-sm px-8">{name}</p>
</div>
<br/>
<br/>
      <h2 className="float-right font-semibold text-[11px]" style={{fontFamily: "Times New Roman"}}>Page 4 of 9</h2>
      <br/>
      <br/>
      <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
      <b>17)</b> While you are in employment of the company, you may be given or handed
        over company’s property and/or equipment for official or business operational
        use and you shall take care of them in their efficient upkeep. On cessation of
        service with the company, you shall return all documents, books, tools,
        papers relating to the affairs of the Company, purchased with the Company’s
        money.
      </p>
       <br/>
      <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
      <b>18)</b> Any balance of advance taken by you from the Company, shall be fully
        recovered from your salary and any other legal dues including Gratuity, at
        the time of your leaving the services of the Company.
      </p>
       <br/>
      <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
      <b>19)</b> While working as an employee if you enter into any business transaction
        with any party on behalf of the company within your permissible limits, it
        shall be your responsibility to ensure recovery of outstanding. If any
        outstanding remains at the time of leaving the services of the company, it
        shall be your responsibility to recover from remittance to the company before
        you proceed to settle your legal dues in final and full settlement of your
        account.
      </p>
      <br/>
      <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
      <b>20)</b> You are required to submit a daily work report in the prescribed format
        before the close of each working day, together with the necessary proof of
        work. This includes uploading geo-tagged live photographs and videos, or any
        other reporting parameters as may be specified by NHWM from time to time.
        Such reports must be uploaded to the system on the same day, no later than
        6:00 P.M., as evidence of activity. In addition, you are expected to achieve
        the performance targets outlined in your Goal Sheet, covering activities from
        Free Sessions to Paid Health Packages, as detailed in Annexure C.
        Non-submission of reports, failure to comply with reporting requirements, or
        non-achievement of targets shall be treated as non-performance and may result
        in disciplinary action, including formal warnings, withholding of salary and
        wages, or separation from employment. Repeated non-compliance for three
        consecutive working days may invite strict action, up to and including
        immediate separation.
      </p>
       <br/>
      <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
      <b>21)</b> All official work must be carried out strictly using authorized devices,
        platforms, and software provided or approved by NHWM. Storage, sharing, or
        transfer of company data through personal devices, accounts, or unauthorized
        applications is strictly prohibited. Any breach of data security will invite
        immediate termination and legal action.
      </p>
       <br/>
      <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
      <b>22)</b> You shall maintain a professional and disturbance-free environment while
        working remotely. Confidential documents, devices, or communication channels
        provided by NHWM must not be used for any personal activity under any
        circumstances.
      </p>
       <br/>
      <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
      <b>23)</b> The company is obliged to deduct Income Tax at source as per the
        provision of Income Tax Act applicable from time to time. Any subsequent
        liabilities arising out of noncompliance will be your personal responsibility
        and the company shall not bear any liability in this respect. The company is
        also obliged to comply with the provisions of all other statutes as
        applicable to the establishment from time to time. While the company shall do
        its best to comply with the provisions of such statutes, it is also your
        responsibility as an employee of the company to comply with these
        requirements without objection.
      </p>
       <br/>
       <br/>
       <br/>
      {/* Accepted by section */}
      <div className="mt-10 flex flex-col items-end" style={{fontFamily: "Times New Roman"}}>
  <p className="text-[11px] px-8">Accepted by:-</p>
  <br />
  <p className="font-semibold text-sm px-8">{name}</p>
</div>
      <br/>
      <br/>
      <h2 className="float-right font-semibold text-[11px]" style={{fontFamily: "Times New Roman"}}>Page 5 of 9</h2>
      <br/>
      <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
      <b>24)</b>	All disputes, claims or matters arising out of or relating to this Appointment Letter, your employment or the interpretation of its terms shall be subject exclusively to the jurisdiction of the competent courts at Guwahati, Assam. 
        No other court or legal forum shall have jurisdiction in such matters 
        and the Guwahati High Court alone shall have the authority to adjudicate any dispute between the employee and NHWM or Optim Health and Wellness (OPC) Private Limited.
        </p>      
        <br/>
        <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
         <b>25)</b>	You are required to remain available and actively engaged during official working hours on all working days. Attendance in scheduled virtual meetings, training sessions and reviews is mandatory and failure to comply will be treated as absenteeism and may attract disciplinary action. 
         You are also expected to devote sufficient time and effort to ensure timely completion of all assigned tasks, 
         and no work should be left pending without prior approval from your reporting authority.
        </p>
        <br/>
        <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
         <b>26)</b>	You will not have any weekend holiday during probation when you fail to complete the task of the programme assigned to you. (See <b>Annexure B</b> and <b>Annexure C</b>) 
        </p>
        <br/>
        <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
        <b>27)</b>	You have to report on a daily basis to <b>{Reporting_RWO}, RWO</b> for the State of <b>{State}</b> and <b>Assigned DWO</b> as well as sometimes to the <b>Mission Director</b> of NHWM. You have to keep & show appropriate respect to the senior management of the Company/NHWM, and you can’t leave your work for the day without the permission from your senior/s.  
        </p>
        <br/>
        <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
          <b>28)</b>	You are required to respond promptly to official calls and messages. 
          Failure to attend calls on three consecutive occasions or repeated non-response to official communications will be treated as irresponsibility and may result in a formal warning or automatic termination of employment.
        </p>
        <br/>
        <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
        <b>29)</b>	No employee shall engage in or make any antisocial or anti-government activity, statement or comment in any form, including public forums, social media or official presentations. 
          Employees of NHWM/Company are strictly prohibited from making any statements, regarding Government policies or schemes or against any medical facility or healthcare system. 
          If any employee is found involved in such acts, they shall be solely responsible for the consequences arising therefrom and NHWM/Company will not be held liable in any manner. 
          Such conduct shall also invite strict disciplinary action, including termination.
        </p>
        <br/>
        <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
        <b>30)</b>	During the course of employment with NHWM, you shall devote your full working time and attention exclusively to the business of the Company. You shall not, directly or indirectly, 
        undertake any other employment, freelance work, consultancy or business activity without the prior written consent of NHWM. 
        Violation of this clause will be treated as misconduct and may lead to immediate termination.
        </p>
        <br/>
        <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
        <b>31)</b>	Zero Tolerance Policy :- <br/>
           We follow a strict Zero Tolerance Policy with respect to the following -  
        <ul className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
          <li>
           a.	Consumption or possession of alcohol 
          </li>
          <li>
           b.	Use of tobacco in any form 
          </li>
          <li>
           c.	Use of vulgar or inappropriate language or behavior towards anyone.  
          </li>
          <li>
           d.	Any form of sexual harassment 
          </li>
          <li>
           e.	Dereliction of duty or negligence in duty  
          </li>
        </ul>
        </p>
        <br/>
        <div className="mt-10 flex flex-col items-end px-8" style={{fontFamily: "Times New Roman"}}>
  <p className="text-[11px]">Accepted by:-</p>
  <br />
  <p className="font-semibold text-sm">{name}</p>
</div>
        <br/>
        <br/>
        <h2 className="float-right font-semibold text-[11px]" style={{fontFamily: "Times New Roman"}}>Page 6 of 9</h2>
        <br/>
        <br/>
      <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
    <strong>32)</strong> The terms and conditions mentioned in this Appointment Letter are strictly confidential. 
    You are not permitted to discuss, disclose, or share any part of this letter with anyone, 
    except with the Company’s Management, without prior written consent. 
    Any breach of this condition will be treated as misconduct and may lead to disciplinary or legal action, 
    including termination of employment.
  </p>
   <br/>
  <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
    <strong>33)</strong> This Appointment Letter shall be valid only upon your acceptance and return of a duly 
    signed copy to the Company’s Management. Unless the accepted copy is received within the stipulated time frame 
    specified by the Company, this offer of appointment shall be treated as null and void, and the Company will not be bound by its terms.
  </p>
  <br/>
  <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
    You are requested to return the enclosed copies duly signed on the stipulated pace of all pages 
    on or before <strong>{Last_date}</strong> as a token of your acceptance of the rules, regulations, 
    terms, and conditions of your employment in <strong>Optim Health and Wellness (OPC) Pvt. Ltd.</strong> or <strong>NHWM</strong>.
  </p>
   <br/>
  <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
    Hope that this will be the beginning of a long and successful career with us.
  </p>
  <br/>
  <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>Yours faithfully,</p>
  <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>For <strong>Optim Health and Wellness (OPC) Pvt. Ltd.</strong></p>
  <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}><strong>ANINDITA KONWAR</strong><br/>
     HR Executive<br/>
     Optim Health and Wellness (OPC) Pvt. Ltd.<br/>
     H. No. 01, Karbi Namghar Path, Guwahati – 36
  </p>
  <br/>
  <h4 className="underline text-center text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
    CONSENT FOR ACCEPTANCE OF THE APPOINTMENT LETTER
  </h4>
  <br/>
  <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>
    I have accepted this Appointment Letter as an <b>AWO</b> in the Dept. of <b>Business Development</b> for the State of <b>{State}</b> covering <b>{district}</b> and nearby district/s. I will abide by the rules, regulations, terms and conditions of the company.
  </p>
  <br/>
  <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}><strong>Signature :-</strong></p>
  <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}><strong>Name :-</strong></p>
  <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}><strong>Date :-</strong></p>
  <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}><strong>Place :-</strong></p>
  <br/>
  <br/>
  <br/>
  <br/>
  <br/>
  <br/>
  <br/>
  <br/>
  <br/>
  <br/>
  <br/>
  <br/>
  <br/>
  <br/>
  <h2 className="float-right font-semibold text-[11px]" style={{fontFamily: "Times New Roman"}}>Page 7 of 9</h2>
  <br/>
  <br/>
  <h3 className="italic font-semibold text-[11px] px-8" style={{fontFamily: "Times New Roman"}}> Annexure - A</h3>
  <br/>
  <h3 className="font-semibold text-[11px] px-8" style={{fontFamily: "Times New Roman"}}> BREAK-UP OF SALARY STRUCTURE FOR RWOs :-</h3>
  <br/>
  <table className="w-full text-[11px] text-gray-700 border-collapse px-8" style={{fontFamily: "Times New Roman"}}>
                <thead className="bg-gray-100 border-b-2 border-gray-300">
                    <tr>
                        <th className="px-4 py-3 text-left font-semibold">EARNINGS CATEGORIES</th>
                        <th className="px-4 py-3 text-left font-semibold">Rs. (P.A.)</th>
                        <th className="px-4 py-3 text-left font-semibold">Earnings Rs. (P.A.)</th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                    <tr>
                        <td className="px-4 py-3 font-semibold">Basic</td>
                        <td className="px-4 py-3">7,500</td>
                        <td className="px-4 py-3">90,000</td>
                    </tr>
                    <tr>
                        <td className="px-4 py-3 font-semibold">House Rent Allowance</td>
                        <td className="px-4 py-3">3,000</td>
                        <td className="px-4 py-3">36,000</td>
                    </tr>
                    <tr>
                        <td className="px-4 py-3 font-semibold">Conveyance allowance</td>
                        <td className="px-4 py-3">2,700</td>
                        <td className="px-4 py-3">32,400</td>
                    </tr>
                    <tr>
                        <td className="px-4 py-3 font-semibold">Miscellaneous allowance</td>
                        <td className="px-4 py-3">1,800</td>
                        <td className="px-4 py-3">21,600</td>
                    </tr>
                </tbody>
                <tfoot className="bg-gray-100 border-t-2 border-gray-300 font-bold">
                    <tr>
                        <td className="px-4 py-3">Gross Earnings</td>
                        <td className="px-4 py-3">15,000/- per month</td>
                        <td className="px-4 py-3">1,80,000/- per annum</td>
                    </tr>
                </tfoot>
            </table>
            <br/>
            <ul className="list-disc list-inside mt-8 text-[11px] space-y-2 px-8" style={{fontFamily: "Times New Roman"}}>
            <li>Reimbursement of expenses will be subject to Company Policy.</li>
            <li>Payment of perquisites, allowances and reimbursements shall be subject to provisions of Income Tax, as applicable.</li>
        </ul>
        <br/>
  <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>Yours faithfully,</p>
  <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>For <strong>Optim Health and Wellness (OPC) Pvt. Ltd.</strong></p>
  <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}><strong>ANINDITA KONWAR</strong><br/>
     HR Executive<br/>
     Optim Health and Wellness (OPC) Pvt. Ltd.<br/>
     H. No. 01, Karbi Namghar Path, Guwahati – 36
  </p>
  <br/>
  <br/>
  <br/>
  <br/>
  <br/>
  <br/>
  <br/>
  <br/>
  <div className="mt-10 flex flex-col items-end" style={{fontFamily: "Times New Roman"}}>
  <p className="text-[11px] px-8">Accepted by:-</p>
  <br />
  <p className="font-semibold text-sm px-8">{name}</p>
</div>
      <br/>
      <br/>
      <h2 className="float-right font-semibold text-[11px]" style={{fontFamily: "Times New Roman"}}>Page 8 of 9</h2>
      <br/>
      <br/>
      <h3 className="italic font-semibold text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>Annexure - B</h3>
      <br/>
      <h3 className="font-semibold text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>JOB RESPONSIBILITIES OF AWOs :-</h3>
      <br/>
      <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>Area Wellness Officers (AWOs) are responsible for arranging & supporting Healthcare & Wellness Awareness, Assessment, and Counselling Programmes, under the supervision of Senior DWOs. They focus on field execution, appointment support, record-keeping, and community engagement.</p>
      <ul className="list-disc list-inside space-y-2 text-[10px] px-8" style={{fontFamily: "Times New Roman"}}>
  <h2 className="font-semibold text-[10px]">Programme Execution</h2>
  <li>Arrange and Assist in conducting awareness programmes, field activities, and wellness counselling sessions.</li>
  <li>Support in organizing health checkups and ensure smooth coordination at the ground level.</li>

  <h2 className="font-semibold text-[10px]">Appointments & On-Ground Support</h2>
  <li>Schedule and follow up on health seeker appointments.</li>
  <li>Provide assistance in area-level mobilization and coordination.</li>

  <h2 className="font-semibold text-[10px]">Record Keeping & Reporting</h2>
  <li>Maintain accurate records of assessments and activities.</li>
  <li>Upload reports, updates, and field data into the system on a daily basis.</li>
  <li>Report directly to the Senior DWO.</li>

  <h2 className="font-semibold text-[10px]">Order Communication</h2>
  <li>Collect health seekers’ supplement/food orders and pass them to the DWO.</li>
  <li>Do not deliver supplements directly, except in urgent cases if instructed.</li>

  <h2 className="font-semibold text-[10px]">Entrepreneur & Community Support</h2>
  <li>Onboard & Assist healthcare entrepreneurs or 2nd-party vendor’s distributors associated with the Mission.</li>
  <li>Promote teamwork, mentorship and shared responsibility.</li>

  <h2 className="font-semibold text-[10px]">Membership and Health Check-up Promotion</h2>
  <li>Actively promote membership & Health Check-up Plans and its benefits across assigned District/s.</li>
  <li>Ensure smooth onboarding and subscription processes.</li>

  <h2>Learning & Growth</h2>
  <li>Participate in training sessions for continuous self-improvement.</li>
  <li>Develop skills to take on higher responsibilities in the Mission structure.</li>

  <h2 className="font-semibold text-[10px]">Other Duties</h2>
  <li>Carry out any additional responsibilities assigned by DWO, RWO, or Mission Director.</li>
</ul>
      <br/>
  <p className="text-[10px] px-8" style={{fontFamily: "Times New Roman"}}>Yours faithfully,</p>
  <p className="text-[10px] px-8" style={{fontFamily: "Times New Roman"}}>For <strong>Optim Health and Wellness (OPC) Pvt. Ltd.</strong></p>
  <p className="text-[10px] px-8" style={{fontFamily: "Times New Roman"}}><strong>ANINDITA KONWAR</strong><br/>
     HR Executive<br/>
     Optim Health and Wellness (OPC) Pvt. Ltd.<br/>
     H. No. 01, Karbi Namghar Path, Guwahati – 36
  </p>
  <div className="mt-10 flex flex-col items-end px-8" style={{fontFamily: "Times New Roman"}}>
  <p className="text-[10px]">Accepted by:-</p>
  <p className="font-semibold text-[10px]">{name}</p>
</div>
      <br/>
      <br/>
      <h2 className="float-right font-semibold text-[11px]" style={{fontFamily: "Times New Roman"}}>Page 9 of 9</h2>
      <br/>
      <br/>
      <h3 className="italic font-semibold text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>Annexure- C</h3>
      <h3 className="font-semibold text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>The Goal sheet will be evaluated on the following parameters and their achievement.</h3>
      <br/>
      <div className="overflow-x-auto mb-8 px-8" style={{fontFamily: "Times New Roman"}}>
      <table className="w-full text-[11px] text-gray-700 border border-gray-300 px-8" style={{fontFamily: "Times New Roman"}}>
                <thead className="bg-gray-100">
                    <tr>
                        <th className="table-cell-custom">Parameters</th>
                        <th className="table-cell-custom">100%</th>
                        <th className="table-cell-custom">50%</th>
                        <th className="table-cell-custom">45%</th>
                        <th className="table-cell-custom">42%</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="table-cell-custom">Nos. of Health Awareness Camps</td>
                        <td className="table-cell-custom text-center">10</td>
                        <td className="table-cell-custom text-center">7</td>
                        <td className="table-cell-custom text-center">6</td>
                        <td className="table-cell-custom text-center">5</td>
                    </tr>
                    <tr>
                        <td className="table-cell-custom text-center"></td>
                        <td className="table-cell-custom text-center">(340 Attendees)</td>
                        <td className="table-cell-custom text-center">(180 Attendees)</td>
                        <td className="table-cell-custom text-center">(170 Attendees)</td>      
                        <td className="table-cell-custom text-center">(160 Attendees)</td>              
                    </tr>
                    <tr>
                        <td className="table-cell-custom">Nos. of Health Check-up Registration</td>
                        <td className="table-cell-custom text-center">36</td>
                        <td className="table-cell-custom text-center">20</td>
                        <td className="table-cell-custom text-center">18</td>
                        <td className="table-cell-custom text-center">16</td>
                        
                    </tr>
                    <tr>
                        <td className="table-cell-custom">Nos. of Membership Registration</td>
                        <td className="table-cell-custom text-center">20</td>
                        <td className="table-cell-custom text-center">12</td>
                        <td className="table-cell-custom text-center">10</td>
                        <td className="table-cell-custom text-center">9</td>
                        
                    </tr>
                    <tr>
                        <td className="table-cell-custom">Supplements Order in INR</td>
                        <td className="table-cell-custom text-center">Rs. 2,00,000</td>
                        <td className="table-cell-custom text-center">Rs. 1,80,000</td>
                        <td className="table-cell-custom text-center">Rs. 90,000</td>
                        <td className="table-cell-custom text-center">Rs. 80,000</td>
                        
                    </tr>
                </tbody>
            </table>
            </div>
            <div>
            <h2 className="text-sm font-bold text-center text-[11px] px-8 mt-[-20px]" style={{fontFamily: "Times New Roman"}}>RMO - MONTH WISE GOAL SHEET BREAK UP :-</h2>
            <div className="overflow-x-auto px-8" style={{fontFamily: "Times New Roman"}}>
                <table className="w-full text-[11px] text-gray-700 border border-gray-300 px-8" style={{fontFamily: "Times New Roman"}}>
                    <thead className="bg-gray-100">
                        <tr>
                            <th className="table-cell-custom">Parameters</th>
                            <th className="table-cell-custom">Month 1 - 2</th>
                            <th className="table-cell-custom">Month 3 - 6</th>
                            <th className="table-cell-custom">Month 7 - 12</th>
                            <th className="table-cell-custom">Month 13 - 24</th>
                            <th className="table-cell-custom">Salary Slabs</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="table-cell-custom">Health Awareness Camps</td>
                            <td className="table-cell-custom text-center">≤42%</td>
                            <td className="table-cell-custom text-center">≤45%</td>
                            <td className="table-cell-custom text-center">≤50%</td>
                            <td className="table-cell-custom text-center">≤60%</td>
                            <td className="table-cell-custom text-center">Hold</td>
                        </tr>
                        <tr>
                          <td className="table-cell-custom"></td>
                            <td className="table-cell-custom text-center">≤45%</td>
                            <td className="table-cell-custom text-center">≤50%</td>
                            <td className="table-cell-custom text-center">≤60%</td>
                            <td className="table-cell-custom text-center">≤65%</td>
                            <td className="table-cell-custom text-center">50%</td>
                        </tr>
                        <tr>
                            <td className="table-cell-custom"></td>
                            <td className="table-cell-custom text-center">≥45%</td>
                            <td className="table-cell-custom text-center">≥50%</td>
                            <td className="table-cell-custom text-center">≥60%</td>
                            <td className="table-cell-custom text-center">≥65%</td>
                            <td className="table-cell-custom text-center">100%</td>
                        </tr>
                        <tr>
                            <td className="table-cell-custom">Health Check-up Registration</td>
                            <td className="table-cell-custom text-center">≤42%</td>
                            <td className="table-cell-custom text-center">≤45%</td>
                            <td className="table-cell-custom text-center">≤50%</td>
                            <td className="table-cell-custom text-center">≤60%</td>
                            <td className="table-cell-custom text-center">Hold</td>
                        </tr>
                        <tr>
                            <td className="table-cell-custom"></td>
                            <td className="table-cell-custom text-center">≤45%</td>
                            <td className="table-cell-custom text-center">≤50%</td>
                            <td className="table-cell-custom text-center">≤60%</td>
                            <td className="table-cell-custom text-center">≤65%</td>
                            <td className="table-cell-custom text-center">50%</td>
                        </tr>
                        <tr>
                            <td className="table-cell-custom"></td>
                            <td className="table-cell-custom text-center">≥45%</td>
                            <td className="table-cell-custom text-center">≥50%</td>
                            <td className="table-cell-custom text-center">≥60%</td>
                            <td className="table-cell-custom text-center">≥65%</td>
                            <td className="table-cell-custom text-center">100%</td>
                        </tr>
                        <tr>
                            <td className="table-cell-custom">Membership Registeration</td>
                            <td className="table-cell-custom text-center">≤42%</td>
                            <td className="table-cell-custom text-center">≤45%</td>
                            <td className="table-cell-custom text-center">≤50%</td>
                            <td className="table-cell-custom text-center">≤60%</td>
                            <td className="table-cell-custom text-center">Hold</td>
                        </tr>
                        <tr>
                            <td className="table-cell-custom"></td>
                            <td className="table-cell-custom text-center">≤45%</td>
                            <td className="table-cell-custom text-center">≤50%</td>
                            <td className="table-cell-custom text-center">≤60%</td>
                            <td className="table-cell-custom text-center">≤65%</td>
                            <td className="table-cell-custom text-center">50%</td>
                        </tr>
                        <tr>
                            <td className="table-cell-custom"></td>
                            <td className="table-cell-custom text-center">≥45%</td>
                            <td className="table-cell-custom text-center">≥50%</td>
                            <td className="table-cell-custom text-center">≥60%</td>
                            <td className="table-cell-custom text-center">≥65%</td>
                            <td className="table-cell-custom text-center">100%</td>
                        </tr>
                        <tr>
                            <td className="table-cell-custom">Supplement Order</td>
                            <td className="table-cell-custom text-center"></td>
                             <td className="table-cell-custom text-center">Rs. 60,000</td>
                            <td className="table-cell-custom text-center">Rs. 1,00,000</td>
                            <td className="table-cell-custom text-center">Rs. 1,50,000</td>
                            <td className="table-cell-custom text-center">100%</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <br/>
        <h2 className="text-sm font-bold text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>SPECIAL MONTHLY INCENTIVE FOR AWO ON GOAL SHEET ACHIEVEMENT:- </h2>
            <ul className="list-disc list-inside text-[11px] px-8 text-[11px]" style={{fontFamily: "Times New Roman"}}>
                <li>If the AWO achieve ≥80% of their monthly Goal Sheet, they will be eligible for a special Incentive of 8% of their Salary</li>
                <li>If the AWO achieve ≥90% of their Goal sheet, they will be eligible for a special Incentive of 12% of their Salary</li>
            </ul>
            <br/>
            <h2 className="text-sm font-bold text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>SPECIAL MONTHLY INCENTIVE FOR AWO ON SUPPLEMENT ORDERs:- </h2>
            <ul className="list-disc list-inside text-[11px] px-8 text-[11px]" style={{fontFamily: "Times New Roman"}}>
                <li>Rs. 1,00,000 to Rs. 2,99,999 -- Incentive Based on performance from 12% of the Company's Incentive Pool</li>
                <li>Rs. 3,00,000 to Rs. 8,99,999 -- Incentive Based on performance from 15% of the Company's Incentive Pool</li>
                <li>Rs. 9,00,000 and above -- Incentive Based on performance from 20% of the Company's Incentive Pool</li>
            </ul>
            <br/>
  <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>Yours faithfully,</p>
  <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}>For <strong>Optim Health and Wellness (OPC) Pvt. Ltd.</strong></p>
  <p className="text-[11px] px-8" style={{fontFamily: "Times New Roman"}}><strong>ANINDITA KONWAR</strong><br/>
     HR Executive<br/>
     Optim Health and Wellness (OPC) Pvt. Ltd.<br/>
     H. No. 01, Karbi Namghar Path, Guwahati – 36
  </p>
  <div className="mt-[-10px] flex flex-col items-end" style={{fontFamily: "Times New Roman"}}>
  <p className="text-[11px] px-8">Accepted by:-</p>
  <br />
  <p className="font-semibold text-sm px-8">{name}</p>
</div>
    </>
    )
}
export default AWOappointment;